import size from './size.js'
const exerptHandler = () => {
    const elements = document.querySelectorAll('.four-articles-container .article-preview__excerpt')

    elements.forEach(el => {

        if (size.isMobile())
            return

        el.innerText = el.innerText.substr(0, 35) + ' ...'
    })

    const elements2 = document.querySelectorAll('.ugb-blog-posts__excerpt')
    if (elements2[0]) {
        elements2[0].className += " first-excerpt"
        elements2.forEach(el => {
            if (el.classList.contains('first-excerpt')) {
                return
            }
            el.innerText = el.innerText.substr(0, 75) + '...'
        })
    }

    const timeTags = document.querySelectorAll('.ugb-blog-posts__date')

    timeTags.forEach(el => {
        let date = new Date(el.getAttribute("datetime"))
        el.innerText = date.getDate() + '.' + date.getMonth() + '.' + date.getYear().toString().substr(-2) + ' | ' + date.getHours() + ':' + date.getMinutes()
    })
}

export default exerptHandler